import { FormatSegment } from '@app/app/_components/DatePicker/FormatSegment';

export function getTotalDigitCount(segments: FormatSegment[]): number {
    return segments.reduce((sum, seg) => (seg.kind !== 'separator' ? sum + seg.length : sum), 0);
}
